module.exports = __webpack_public_path__ + "img/34.00d6ee3c.jpg";